// @flow
import * as React from 'react';
import type { SvgComponentProps } from '~/core/icons/svg-icons/types';

const CameraDeharo = ({ fill, svgComponents: { G, Path } }: SvgComponentProps) => {
    const gProps = fill ? { fill } : {};
    /*eslint-disable max-len */
    return (
        <G {...gProps} transform="translate(-66.000000, -288.000000)">
            <G transform="translate(16.000000, 160.000000)">
                <Path d="M84.5,130.2H55.6c-0.4,0-0.8,0.2-1.2,0.5c-0.3,0.4-0.5,0.8-0.5,1.2v28.9c0,0.5,0.2,0.9,0.5,1.2c0.3,0.3,0.7,0.5,1.2,0.5
        			h7.8c0.1,1.1,0.5,1.9,1.2,2.6c0.8,0.7,1.7,1,2.7,1h5.5c1.1,0,2-0.3,2.7-1c0.8-0.7,1.2-1.5,1.2-2.6h7.8c1.2,0,1.8-0.6,1.8-1.7V132
        			c0-0.4-0.2-0.9-0.5-1.2C85.4,130.4,85,130.2,84.5,130.2L84.5,130.2z M72.8,165.3h-5.4c-0.8,0-1.5-0.3-2.1-0.8
        			c-0.6-0.5-0.9-1.2-1.1-1.9h11.6c-0.1,0.8-0.5,1.4-1.1,1.9C74.2,165,73.5,165.3,72.8,165.3L72.8,165.3z M85.3,160.9
        			c0,0.5-0.3,0.8-0.8,0.8H55.6c-0.5,0-0.8-0.3-0.8-0.8V132c0-0.6,0.3-0.8,0.8-0.8h28.9c0.6,0,0.8,0.3,0.8,0.8V160.9z M70.1,141.8
        			c-1.3,0-2.4,0.5-3.3,1.4c-0.9,0.9-1.4,2-1.4,3.3c0,1.3,0.5,2.4,1.4,3.3c0.9,0.9,2,1.4,3.3,1.4s2.4-0.5,3.3-1.4
        			c0.9-0.9,1.4-2,1.4-3.3c0-1.3-0.5-2.4-1.4-3.3C72.5,142.2,71.4,141.8,70.1,141.8L70.1,141.8z M70.1,150.3c-1.1,0-2-0.4-2.7-1.1
        			c-0.7-0.7-1.1-1.6-1.1-2.7s0.4-2,1.1-2.7c0.7-0.7,1.6-1.1,2.7-1.1c1.1,0,2,0.4,2.7,1.1c0.7,0.7,1.1,1.6,1.1,2.7s-0.4,2-1.1,2.7
        			C72,149.9,71.1,150.3,70.1,150.3L70.1,150.3z M70.1,138.4c-2.2,0-4.2,0.8-5.8,2.4c-1.6,1.6-2.4,3.5-2.4,5.7c0,2.2,0.8,4.2,2.4,5.8
        			c1.6,1.6,3.5,2.4,5.8,2.4c2.2,0,4.2-0.8,5.8-2.4s2.4-3.5,2.4-5.8c0-2.2-0.8-4.2-2.4-5.7S72.3,138.4,70.1,138.4L70.1,138.4z
        			 M70.1,153.6c-2,0-3.7-0.7-5.1-2.1c-1.4-1.4-2.1-3.1-2.1-5.1c0-2,0.7-3.7,2.1-5.1c1.4-1.4,3.1-2.1,5.1-2.1c2,0,3.7,0.7,5.1,2.1
        			c1.4,1.4,2.1,3.1,2.1,5.1c0,2-0.7,3.7-2.1,5.1S72,153.6,70.1,153.6L70.1,153.6z" />
            </G>
        </G>
    );
    /*eslint-enable max-len */
};

export default CameraDeharo;



// WEBPACK FOOTER //
// ./src/core/icons/svg-icons/devices/camera-deharo/index.js